import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import SimpleSearch from "@/components/SimpleSearch";
import AdvancedSearch from "@/components/AdvancedSearch";

export default new Router({
    routes: [
        {path: '/', component: SimpleSearch, beforeEnter: checkIfPathExists},
        {path: '/advanced', component: AdvancedSearch, beforeEnter: checkIfPathExists},
    ]
});

function checkIfPathExists(to, from, next) {

    // if (to.fullPath == from.fullPath) {
    //     console.log('asdasdas');
    //     return
    // }
    next();
}